import React from 'react';
import { SlideContainer } from './SlideContainer';
import slideCapaImg from '../assets/SlideCapa2.jpg';
import { ISlidePropostaData } from '../interface';

export interface SlideCapaProps {
  data?: ISlidePropostaData;
  scale?: number;
}

export const SlideCapa: React.FC<SlideCapaProps> = ({ data, scale = 1 }) => {
  return (
    <SlideContainer showFooterLogo={false} showWaves={false} noPadding={true} scale={scale} data={data}>
      <img
        src={slideCapaImg}
        alt="GovFácil Proposta Comercial"
        draggable={false}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: 'block',
          userSelect: 'none',
          WebkitUserSelect: 'none',
          pointerEvents: 'none',
        }}
      />
    </SlideContainer>
  );
};